export default {
  SURVEY_STATUS_FINISHED: 5,
  FOREIGN_SURVEY_TYPE_HOLIDAYCHECK: 1

}



// WEBPACK FOOTER //
// ./src/constants.js